import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { media } from '../../services/media';
import { themeStyles } from '../../services/themeStyles';

const SectionUpscore = themeStyles(
    'upscore',
    css`
        ${media.max('md')} {
            margin-bottom: -1.6vw;
        }

        ${media.min('md')} {
            margin-bottom: -0.9vw;
        }
    `,
);

const SectionPengeStyrke = themeStyles(
    'pengestyrke',
    css`
        max-width: 1200px;
        margin: 20px auto;
        padding: 0 15px;

        ${media.min('md')} {
            margin: 40px auto;
        }
    `,
);

export const Section = styled.section`
    ${SectionUpscore}
    ${SectionPengeStyrke}
`;

export const WrapperAsLink = css`
    position: relative;

    &:after {
        content: '';
        position: absolute;
        opacity: 0;
        background-color: #000000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: opacity 250ms ease-in-out;
    }
    cursor: pointer;

    &:hover:after {
        opacity: 0.4;
    }
`;

export const Wrapper = styled.div<{ asLink: string }>`
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    height: auto;

    ${(props) => props.asLink && WrapperAsLink}
`;

export const Video = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const Poster = styled(ResponsiveImage)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    object-fit: cover;
    object-position: center;
`;
